import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { AddIcon, SearchIcon } from "../../../Resources/Icons/icons";
import { GetAddOn, UpdateAddOn, FilterAddOn } from "../../../Service/_index";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import AddAddOn from "./AddAddOn";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import Box from "@mui/material/Box";
import DisabledImage from "../../../Resources/Images/disable.png";
import ActiveImage from "../../../Resources/Images/ActiveImage.png";
import { set } from "rsuite/esm/internals/utils/date";

const FilterOption = [
  {
    label: "All Data",
    isEnabled: "all",
    value: 1,
  },
  {
    label: "ActiveData",
    isEnabled: "true",
    value: 2,
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
    value: 3,
  },
];

const AddOn = () => {
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [addOn, setAddOn] = React.useState([]);
  const [activeBoolean, setActiveBoolean] = useState();
  const [pageView, setPageView] = useState(2);
  const [formType, setFormType] = useState("");
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const columns = [
    { id: "addOn", label: "Add On", width: 200 },
    { id: "remarks", label: "Remark", width: 200 },
    {
      id: "isEnabled",
      label: "Status",
      width: 150,
      type: "render",
      render: (row) => (
        <div>
          {row.isEnabled ? (
            <div className="Active_Container">
              <div />
              <span className="ActiveLabel">Active</span>
            </div>
          ) : (
            <div className="InActive_Container">
              <div />
              <span className="InActiveLabel">Inactive</span>
            </div>
          )}
        </div>
      ),
    },
  ];

  const GetData = () => {
    setLoading(true);
    GetAddOn({ isAscending: false }).then((res) => {
      setAddOn(res?.data);
    });
    setLoading(false);
  };

  const GetActiveData = () => {
    setLoading(true);
    GetAddOn({ isAscending: false }).then((res) => {
      setAddOn(res.data.filter((item) => item.isEnabled === true));
    });
    setLoading(false);
  };
  const GetInActiveData = () => {
    setLoading(true);
    GetAddOn({ isAscending: false }).then((res) => {
      setAddOn(res.data.filter((item) => item.isEnabled === false));
    });
    setLoading(false);
  };

  React.useEffect(() => {
    GetActiveData();
  }, []);

  const EditAddOnData = (row) => {
    setSelectedData(row);
    setOpenDrawer(true);
    setFormType("edit");
  };

  const CreateAddOnData = () => {
    setSelectedData({});
    setOpenDrawer(true);
    setFormType("add");
  };
  const ViewAddOnData = (row) => {
    setSelectedData(row);
    setOpenDrawer(true);
    setFormType("view");
  };

  const ActiveAddOnData = (row, active) => {
    setOpenConfirmBox(true);
    setSelectedData(row);
    setActiveBoolean(!active);
  };

  const ActiveFunction = () => {
    UpdateAddOn(selectedData._id, { isEnabled: activeBoolean }).then((res) => {
      switch (pageView) {
        case 1:
          GetData();
          break;
        case 2:
          GetActiveData();
          break;
        case 3:
          GetInActiveData();
          break;
        default:
          break;
      }
    });
    setOpenConfirmBox(false);
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.addOn}${el?.remarks}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
  };

  const FilterAddOnFunction = (e) => {
    setPageView(e?.value);
    if (e?.isEnabled === "all") {
      GetData();
    } else {
      FilterAddOn({ isEnabled: e?.isEnabled }).then((res) => {
        setAddOn(res?.data);
      });
    }
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container className="Master_Header_Container" spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography className="Master_Header_Heading">Add On</Typography>
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
          <Grid item xs={12} sm={2}>
            <Input
              focused="false"
              className="w-100 Master_Header_Input"
              id="standard-adornment-password"
              onChange={onSearch}
              disableUnderline={true}
              placeholder="Search"
              startAdornment={
                <InputAdornment position="start">
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              className="w-100 Master_Header_Filter"
              onChange={(option, value) => {
                FilterAddOnFunction(value);
              }}
              clearIcon={false}
              defaultValue={FilterOption.find(
                (option) => option.label === "ActiveData"
              )}
              options={FilterOption}
              renderInput={(params) => (
                <TextField {...params} focused={false} />
              )}
              isOptionEqualToValue={(option, value) =>
                option.label === value.label
              }
            />
          </Grid>
          <Grid item xs={12} sm={1} className="d-flex justify-content-end">
            <Button
              className="Master_Header_create_Button w-100"
              endIcon={<AddIcon />}
              onClick={() => CreateAddOnData()}
            >
              Create
            </Button>
          </Grid>
        </Grid>
      </Box>
      <div className="d-flex PageContainer">
        <div className="container-fluid TableBox">
          <MasterCommonTable
            columns={columns}
            data={filter.fn(addOn)}
            handleEdit={EditAddOnData}
            handleView={ViewAddOnData}
            handleApprove={ActiveAddOnData}
            tableConfig={{
              isAction: true,
              isEdit: true,
              isView: true,
              isSwitch: true,
              historyEntity: "addOn",
            }}
            loading={loading}
          />
        </div>
      </div>
      <Dialog
        open={openDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            maxWidth: "50%",
          },
        }}
      >
        {openDrawer ? (
          <AddAddOn
            title={
              formType === "edit"
                ? "Edit"
                : formType === "view"
                ? "View"
                : "Create"
            }
            selectedData={selectedData}
            formType={formType}
            setOpenDrawer={setOpenDrawer}
            GetActiveData={GetActiveData}
          />
        ) : null}
      </Dialog>
      <ConfirmBox
        open={openConfirmBox}
        title={selectedData.isEnabled ? "Inactive" : "Active"}
        content={`Are you sure want to ${
          selectedData.isEnabled ? "Inactive" : "Active"
        }`}
        confirmButton={selectedData.isEnabled ? "Inactive" : "Active"}
        setOpenConfirmBox={setOpenConfirmBox}
        Function={ActiveFunction}
        img={selectedData.isEnabled ? DisabledImage : ActiveImage}
        color={selectedData.isEnabled ? "error" : "success"}
      />
    </>
  );
};
export default AddOn;
